import TextBlock from "../../typeComponents/TextBlock";
import MainHeading from "../../typeComponents/MainHeading";
import Paragraph from "../../typeComponents/Paragraph";
import CureLogoCleanVector from "../../images/CURE_logo_clean_vector.svg";
import { Box } from "@mui/material";

const ProjectPlanning = () => {
  return (
    <TextBlock>
      <MainHeading>How to Make Your Project Happen!</MainHeading>
      <Box sx={{ width: { xs: "45vw", md: "24vw" }, padding: "10px" }}>
        <img src={CureLogoCleanVector} alt="CURE Montreal Logo" />
      </Box>
      <Paragraph>
        Hiya, below are the slides that we use in our workshops! We're working
        on making a more web-friendly version that will hopefully be up soon!
      </Paragraph>
      <img
        src="https://i.ibb.co/KzjzdK4y/Making-It-Happen.jpg"
        alt="Making-It-Happen"
        border="0"
      />
      <img
        src="https://i.ibb.co/gZVFQCKD/Making-It-Happen-2.jpg"
        alt="Making-It-Happen-2"
        border="0"
      />
      <img
        src="https://i.ibb.co/pvK6WgJC/Making-It-Happen-3.jpg"
        alt="Making-It-Happen-3"
        border="0"
      />
      <img
        src="https://i.ibb.co/RG0p4qhR/Making-It-Happen-4.jpg"
        alt="Making-It-Happen-4"
        border="0"
      />
      <img
        src="https://i.ibb.co/v8TLTj2/Making-It-Happen-5.jpg"
        alt="Making-It-Happen-5"
        border="0"
      />
      <img
        src="https://i.ibb.co/zHtFD1Rj/Making-It-Happen-6.jpg"
        alt="Making-It-Happen-6"
        border="0"
      />
      <img
        src="https://i.ibb.co/XfjpDFPg/Making-It-Happen-7.jpg"
        alt="Making-It-Happen-7"
        border="0"
      />
      <img
        src="https://i.ibb.co/qFjwtmBq/Making-It-Happen-8.jpg"
        alt="Making-It-Happen-8"
        border="0"
      />
      <img
        src="https://i.ibb.co/6RvMy5YR/Making-It-Happen-9.jpg"
        alt="Making-It-Happen-9"
        border="0"
      />
      <img
        src="https://i.ibb.co/LdBHYbQT/Making-It-Happen-10.jpg"
        alt="Making-It-Happen-10"
        border="0"
      />
      <img
        src="https://i.ibb.co/mCkRXxhY/Making-It-Happen-11.jpg"
        alt="Making-It-Happen-11"
        border="0"
      />
      <img
        src="https://i.ibb.co/vvRNjWPZ/Making-It-Happen-12.jpg"
        alt="Making-It-Happen-12"
        border="0"
      />
      <img
        src="https://i.ibb.co/R4zGVzG6/Making-It-Happen-13.jpg"
        alt="Making-It-Happen-13"
        border="0"
      />
      <img
        src="https://i.ibb.co/k2MpRGXs/Making-It-Happen-14.jpg"
        alt="Making-It-Happen-14"
        border="0"
      />
    </TextBlock>
  );
};

export default ProjectPlanning;
